import { AxiosInstance } from "axios";
import { IAutocompleteFieldsResponse } from "./types";

const getAtocompleteData = (authenticatedRequest: AxiosInstance, id: string) =>
  authenticatedRequest.get<IAutocompleteFieldsResponse>(
    `/api/v2/autocomplete/user/${id}`
  );

const getTransmittersAutocomplete = (
  authenticatedRequest: AxiosInstance,
  transmitterId: string
) =>
  authenticatedRequest.get<IAutocompleteFieldsResponse>(
    `/api/v2/autocomplete/transmitter/${transmitterId}`
  );

const getAddressesAutocomplete = async (
  objectId: string,
  authenticatedRequest: AxiosInstance
) =>
  authenticatedRequest.get<IAutocompleteFieldsResponse>(
    `/api/v2/autocomplete/user/${objectId}/address`
  );

export {
  getAtocompleteData,
  getTransmittersAutocomplete,
  getAddressesAutocomplete,
};
